import styles from "./styles.module.css";

export function PrintPageBreak() {
	return <div className={styles["print-page-break"]}></div>;
}
